// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3OwTF","profileWrapper":"styles_profileWrapper__hv4Vx","photo":"styles_photo__3Mwdt","name":"styles_name__UFV1i","lastDate":"styles_lastDate__1Gq9C"};